import { render } from "./CompareStart.vue?vue&type=template&id=f338ada0"
import script from "./CompareStart.vue?vue&type=script&lang=js"
export * from "./CompareStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__